import { type FunctionalComponent, h, type VNode } from '@stencil/core';
import { GuidedGenericQuickLink } from '../../models/quick-link';
import imagePlaceholderGS from '../../../../assets/svg/doc_image_placeholder_gs.svg';
import type { GuidedV2Emitters } from '../../models/eventNames';
import type { labelProviderInterface } from '../../../LabelProviderInterface';
import { downloadFile } from '../../../result-page/search-tab/tabular/utils';
import { GuidedV2LinkAttributeRender } from '../link-attribute-render/link-attribute-render';
import { GuidedV2LinkTagRender } from '../link-tag-render/link-tag-renderer';

export interface GuidedDownloadDocumentsQuickLinkProps
  extends GuidedGenericQuickLink {
  eventEmitters?: GuidedV2Emitters;
  labelProvider?: labelProviderInterface;
}

export const quickLinkDownloadDocuments: () => FunctionalComponent<GuidedDownloadDocumentsQuickLinkProps> =
  () => {
      return (props) => {
          const {
            quickLinkDescription,
            quickLinkCategory,
            quickLinkTitle,
            quickLinkOpenUrl,
            eventEmitters,
            quickLinkBadges,
            quickLinkImage,
            quickLinkAttachment,
          } = props;

          const emitters = eventEmitters() ?? undefined;

          const clickEmitter = (ev: MouseEvent) => {
              const clickEvent = emitters?.completed?.emit({
                link: quickLinkOpenUrl || quickLinkAttachment.downloadUrl,
                event: 'guidedSearchClick',
                category: quickLinkCategory,
              });

              if (clickEvent.defaultPrevented) {
                ev.preventDefault();
              }
          };

          const handleClick = (ev: MouseEvent) => {
              clickEmitter(ev);
              if (quickLinkOpenUrl) return;
              ev.preventDefault();
              downloadFile(quickLinkAttachment.downloadUrl, quickLinkAttachment.name);
          };

          return (
        <li
          class="guided-v2-result-list-section__result add-selector-strength"
          style={{ cursor: 'pointer' }}
        >
          <a
            class="guided-v2-result-list-section__result-link add-selector-strength document-download"
            href={quickLinkOpenUrl}
            target="_blank"
            onClick={handleClick}
          >
            <div class="guided-v2-result-list-section__result-content">
              <uiaas-guided-v2-link-image
                src={quickLinkImage}
                alt={quickLinkTitle}
                customPlaceholder={imagePlaceholderGS}
                customPlaceholderClass="placeholder__document-download"
              />
              <div>
                <div class="guided-v2-result-list-section__result-title add-selector-strength">
                  {quickLinkTitle}
                  {quickLinkDescription && (
                    <span>- {quickLinkDescription}</span>
                  )}
                </div>
                <div class="guided-v2-result-list-section__result-extra add-selector-strength">
                  {quickLinkBadges.attributes.map((attribute) => (
                    <GuidedV2LinkAttributeRender
                      attribute={attribute}
                    ></GuidedV2LinkAttributeRender>
                  ))}

                  {quickLinkBadges.tags.map((tag) => (
                    <GuidedV2LinkTagRender tag={tag}></GuidedV2LinkTagRender>
                  ))}
                </div>
              </div>
            </div>
            {quickLinkOpenUrl ? (
              <div class="guided-v2-result-list-section__result-icon">
                <qds-icon name="arrow-top-right-on-square" size="large" />
              </div>
            ) : (
              <div class="guided-v2-result-list-section__result-icon">
                <qds-icon name="arrow-down-tray" size="large" />
              </div>
            )}
          </a>
        </li>
      ) as VNode;
      };
  };
